(() => {
  // app/scripts/find-a-store.js
  customElements.define(
    "popup-find-a-store",
    class extends HTMLElement {
      constructor() {
        super();
        this.states = [];
        this.template = this.querySelector("#inforPopupfindastore");
        this.container = null;
        this.addEventListener("click", this.handleSelectChange);
      }
      connectedCallback() {
        this.init();
      }
      async init() {
        const productJsonStore = document.querySelector('[id="product-stores-metafield"]');
        const stores = JSON.parse(productJsonStore.textContent);
        if (stores.count > 50) {
          const res = await fetch(`${theme.routes.search}?view=find-in-store&q=${stores.product_handle}`);
          const text = await res.text();
          const html = new DOMParser().parseFromString(text, "text/html");
          const _productJsonStore = html.querySelector('[id="product-stores-metafield"]');
          const _stores = JSON.parse(_productJsonStore.textContent);
          const number_of_fetches = Math.floor(stores.count / 50);
          const urls = [];
          for (let index = 0; index < number_of_fetches; index++) {
            urls.push(`${theme.routes.search}?view=find-in-store&q=${stores.product_handle}&${_stores.page_param}=${index + 2}`);
          }
          await Promise.all(
            urls.map(async (url) => {
              const resp = await fetch(url);
              const text2 = await resp.text();
              const html2 = new DOMParser().parseFromString(text2, "text/html");
              const _productJsonStore2 = html2.querySelector('[id="product-stores-metafield"]');
              const _stores2 = JSON.parse(_productJsonStore2.textContent);
              stores.list_store = [...stores.list_store, ..._stores2.list_store];
            })
          );
        }
        this.states = this.transformData(stores.list_store);
        this.container = this.querySelector(".findastore-scroller");
        this.sortArray(this.states);
        this.renderStores(this.states);
        if (stores.count > 50) {
          const customSelect = this.querySelector("#popupfindastore");
          const customSelectCloned = customSelect.cloneNode(true);
          const list = customSelectCloned.querySelector(".custom-select__listbox");
          const itemCloned = list.querySelector(".custom-select__option").cloneNode(true);
          const allStates = this.states.map((obj) => obj.state).filter((ele) => ele != null);
          allStates.unshift(stores.selected_value);
          list.innerHTML = "";
          for (let index = 0; index < allStates.length; index++) {
            const element = allStates[index];
            const newItem = itemCloned.cloneNode(true);
            newItem.id = `${stores.id}-opt-${index}`;
            newItem.querySelector("span").innerHTML = element;
            newItem.removeAttribute("aria-selected");
            newItem.setAttribute("data-value", element);
            list.insertAdjacentElement("beforeend", newItem);
          }
          customSelect.replaceWith(customSelectCloned);
          customSelectCloned.classList.add("customSelectCloned");
        }
      }
      transformData(stores) {
        return Object.values(
          stores.reduce((acc, store) => {
            const { state, ...storeData } = store;
            if (!acc[state]) {
              acc[state] = { state, stores: [] };
            }
            acc[state].stores.push(storeData);
            return acc;
          }, {})
        );
      }
      handleSelectChange(event) {
        const target = event.target;
        if (target.closest("li.custom-select__option")) {
          const valueSelect = target.closest("li.custom-select__option").dataset.value;
          const filteredStates = valueSelect === "Select state" ? this.states : this.states.filter((state) => state.state === valueSelect);
          this.renderStores(filteredStates);
        }
      }
      renderStores(states) {
        this.container.innerHTML = "";
        states.forEach((stateData) => {
          const template = this.template.content.cloneNode(true);
          const state = template.querySelector(".state-group");
          state.setAttribute("data-key", stateData.state);
          state.querySelector(".state-name").textContent = stateData.state;
          const storeGroup = state.querySelector(".store-group");
          storeGroup.innerHTML = "";
          this.sortArray(stateData.stores, "name");
          stateData.stores.forEach((store) => {
            const storeElement = this.createStoreElement(store, stateData.state);
            storeGroup.appendChild(storeElement);
          });
          this.container.appendChild(state);
        });
        this.container.querySelectorAll(".state-group").forEach((group) => {
          const storesInGroup = group.querySelectorAll(".store");
          const visibleStore = [...storesInGroup].find((store) => store.hidden == false);
          if (!visibleStore)
            group.hidden = true;
        });
      }
      sortArray(data, key = "state") {
        data.sort((a, b) => {
          const stateA = a[key]?.toLowerCase() || "";
          const stateB = b[key]?.toLowerCase() || "";
          if (!stateA && stateB)
            return 1;
          if (stateA && !stateB)
            return -1;
          if (!stateA && !stateB)
            return 0;
          return stateA.localeCompare(stateB);
        });
      }
      createStoreElement(store, state) {
        const template = this.template.content.cloneNode(true);
        const storeElement = template.querySelector(".store").cloneNode(true);
        storeElement.querySelector(".company-name").textContent = store.name;
        const address = store.address.replace(/\n/g, "<br>").replace(/,/g, "");
        storeElement.querySelector(".address").innerHTML = address;
        storeElement.querySelector(".phone").textContent = store.phone;
        storeElement.querySelector(".email").textContent = store.email;
        storeElement.querySelector(".email").href = "mailto:" + store.email;
        storeElement.querySelector(".zip").textContent = store.zip;
        storeElement.querySelector(".website").textContent = store.website;
        storeElement.querySelector(".website").href = store.website;
        storeElement.querySelector(".state").textContent = state;
        if (state && state.length > 1) {
          storeElement.querySelector(".city").innerHTML = store.city + ", ";
        } else {
          storeElement.querySelector(".city").innerHTML = store.city;
        }
        if (store.company_consent == "false") {
          storeElement.hidden = true;
        }
        return storeElement;
      }
    }
  );
})();
